<nb-card class="card-container">
  <nb-card-body class="card-body-container">
    <div class="card-body-container-inner">
      <h1 class="title">Forgot Password</h1>
      <p class="sub-title">
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Earum, sunt.
      </p>

      <div class="form-container">
        <form [formGroup]="passwordResetRequestFormGroup" (submit)="onSubmit()">
          <nb-form-field>
            <input
              nbInput
              groceriyaValidatedInput
              fullWidth
              formFieldConfigKey="request-password-reset-email-text-input"
              type="email"
              [formControl]="getFormControl('email')"
            />
          </nb-form-field>

          <button
            class="action-button"
            nbButton
            fullwidth
            shape="round"
            size="medium"
            status="primary"
            [nbSpinner]="isProcessing"
            nbSpinnerStatus="primary"
            [disabled]="!isFormValid || isProcessing"
          >
            Request Password Reset
          </button>

          <span class="label-link">
            <a [routerLink]="authUrl + '/login'" class="back-to-login caption-2"
              >Back to Log In</a
            >
          </span>
        </form>
      </div>
    </div>
  </nb-card-body>
  <p class="copyright-text">Copyright © 2021 Groceria</p>
</nb-card>
